export default class ConfirmButton extends P3.Button {
    constructor(states) {
        super(states);

        this.enabledSwapStates = false;

        this._timerArc = new PIXI.Graphics();
        this.animation.addChild(this._timerArc);

        //Reorder icon on top of the timer arc.
        this.animation.addChild(this._icon);

        this.setTimerAmount(0);
    }

    setTimerAmount(value) {
        const t = P3.math.clamp(value, 0, 1);

        if (t === 0) {
            this._timerArc.visible = false;
        } else {
            this._drawArc(360 * t, 52);
            this._timerArc.visible = true;
        }
    }

    _drawArc(angle, radius) {
        this._timerArc.clear();
        this._timerArc.beginFill(0x0, 1);
        this._timerArc.moveTo(0, 0);

        for (let i = 0; i <= angle; ++i) {
            const theta = -Math.PI * 0.5 + i * PIXI.DEG_TO_RAD;
            this._timerArc.lineTo(-Math.cos(theta) * radius, Math.sin(theta) * radius);
        }
    }
}